import { useState, useEffect } from "react"
import {LOCAL_STORAGE_PREFIX} from '../config'
const initAnswerStorage = (key: string) => {
  const item = localStorage.getItem(key)
  if (item) return JSON.parse(item)
  return {}
}


export const useLocalAnswerStorage = (gameId: string, round: number)
:[string, (answer:string)=> void] => {
  const key = `${LOCAL_STORAGE_PREFIX}-${gameId}`
  const [answers, setAnswers] = useState(initAnswerStorage(key))


  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(answers))
  }, [ answers ])

  const saveAnswer= (answer: string)=> {
    const a = {...answers}
    a[round] = answer
    setAnswers(a)
  }

  return [answers[round], saveAnswer]

}